/**
 * Estilo de las fichas: **tarjetas, sin vuelta atrás**.
 *
 * La variante «clásica» se retiró el 2026-10-30. `getServerFormStyle()` se
 * mantiene porque la usan los listados para pasar `variant` a su ficha, pero
 * ya devuelve siempre `cards`: no hay preferencia que leer, ni query string ni
 * variable de entorno que permita volver atrás.
 *
 * Para una ficha nueva NO se escribe una segunda variante: se hace en tarjetas
 * con `FormCardsShell` + `FormCardsHead` (ver `docs/FICHA_ESTANDAR_TARJETAS.md`).
 */

export const CLAVE_ESTILO_FICHA = 'cmdb.serverFormStyle';
export const ESTILO_CLASICO = 'classic';
export const ESTILO_TARJETAS = 'cards';

export function getServerFormStyle() {
  return ESTILO_TARJETAS;
}

/** Sin efecto: la clásica ya no existe. Se conserva por compatibilidad. */
export function setServerFormStyle() {
  try { localStorage.removeItem(CLAVE_ESTILO_FICHA); } catch { /* modo privado */ }
}

export function esEstiloTarjetas() {
  return true;
}
